import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';
//import { getEmpresaId } from '../services/sessionService';

export default function EditarInstrumento() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [campos, setCampos] = useState([]);
  const [valores, setValores] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorCarga, setErrorCarga] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [mensajeError, setMensajeError] = useState('');
  const etiquetasCampos = {
    nombre: 'Nombre',
    identificacion: 'Identificación',
    rango_medicion: 'Rango de medición',
    marca: 'Marca',
    modelo: 'Modelo',
    numero_serie: 'Número de serie',
    ubicacion: 'Ubicación',
    estado_calibracion: 'Estado de calibración',
    proveedor: 'Proveedor',
    notas: 'Notas',
    fecha_ultima: 'Fecha última',
    fecha_proxima: 'Fecha próxima',
    periodicidad_meses: 'Periodicidad (meses)',
    tolerancia: 'Tolerancia',
    precio: 'Precio',
    tipo: 'Tipo',
    condicion: 'Condición',
    certificado: 'Certificado',
    carta: 'Carta',
    asignado: 'Asignado a',
    created_at: 'Fecha de creación',
  };

  const obtenerEtiqueta = (campo) =>
    etiquetasCampos[campo] ||
    campo
      .replaceAll('_', ' ')
      .replace(/\b\w/g, (letra) => letra.toUpperCase());

  useEffect(() => {
    let cancelado = false;

    const cargarDatos = async () => {
      setLoading(true);
      setErrorCarga('');

      try {
        const { data: columnas, error: errorColumnas } = await supabase
          .rpc('get_column_names', { table_name_input: 'instrumentos' })
          .abortSignal(AbortSignal.timeout(8000));

        if (errorColumnas) {
          throw new Error(`Columnas: ${errorColumnas.message}`);
        }

        const columnasExcluidas = [
          'id',
          'empresa_id',
          'activo',
          'created_at',
          'updated_at',
          'creado_en',
          'creadoEn',
        ];

        const nombresColumnas = (columnas || [])
          .map((col) => col.column_name)
          .filter((c) => !columnasExcluidas.includes(c));

        const { data: instrumento, error: errorInstrumento } = await supabase
          .from('instrumentos')
          .select('*')
          .eq('id', id)
          .eq('activo', true)
          .abortSignal(AbortSignal.timeout(8000))
          .maybeSingle();
        if (errorInstrumento) {
          throw new Error(`Instrumento: ${errorInstrumento.message}`);
        }

        if (!instrumento) {
          if (!cancelado) {
            setErrorCarga(
              'El instrumento solicitado no existe o ya no está disponible.'
            );
          }
          return;
        }

        if (!cancelado) {
          setCampos(nombresColumnas);
          setValores(instrumento);
        }
      } catch (error) {
        console.error('❌ Error cargando instrumento:', error);

        if (!cancelado) {
          setErrorCarga(
            'No se pudo cargar el instrumento. Verifica tu conexión e inténtalo nuevamente.'
          );
        }
      } finally {
        if (!cancelado) {
          setLoading(false);
        }
      }
    };

    cargarDatos();

    return () => {
      cancelado = true;
    };
  }, [id]);

  const handleChange = (campo, valor) => {
    setValores(prev => ({ ...prev, [campo]: valor }));
  };

  const handleGuardar = async () => {
    if (guardando) return;

    setGuardando(true);
    setMensaje('');
    setMensajeError('');

    try {
      const { error } = await supabase
        .from('instrumentos')
        .update(valores)
        .eq('id', id)
        .abortSignal(AbortSignal.timeout(8000));

      if (error) {
        throw error;
      }

      setMensaje('Cambios guardados correctamente.');

      setTimeout(() => {
        navigate('/instrumentos');
      }, 800);
    } catch (error) {
      console.error('❌ Error al guardar cambios:', error);
      setMensajeError(
        'No se pudieron guardar los cambios. Verifica tu conexión e inténtalo nuevamente.'
      );
    } finally {
      setGuardando(false);
    }
  };

  if (loading) {
    return (
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <p className="text-sm text-slate-500">Cargando instrumento...</p>
        </div>
      </div>
    );
  }

if (errorCarga) {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="max-w-3xl rounded-2xl border border-red-200 bg-white p-6 shadow-sm">
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
          {errorCarga}
        </div>

        <button
          onClick={() => navigate('/instrumentos')}
          className="mt-4 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        >
          Volver a Instrumentos
        </button>
      </div>
    </div>
  );
}

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-6">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-600">
          Instrumentos
        </p>

        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Editar instrumento
        </h1>

        <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
          Actualiza la información del instrumento y conserva sus datos al día.
        </p>
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-200 px-5 py-4 sm:px-6">
          <h2 className="font-semibold text-slate-900">
            Información del instrumento
          </h2>

          <p className="mt-1 text-xs text-slate-500">
            Modifica únicamente los datos que necesites actualizar.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-x-6 gap-y-5 p-5 sm:p-6 md:grid-cols-2">
          {campos.map((campo, index) => (
            <div
              key={index}
              className={campo === 'notas' ? 'md:col-span-2' : ''}
            >
              <label
                htmlFor={`campo-${campo}`}
                className="mb-2 block text-sm font-medium text-slate-700"
              >
                {obtenerEtiqueta(campo)}
              </label>

              {campo === 'notas' ? (
                <textarea
                  id={`campo-${campo}`}
                  value={valores[campo] || ''}
                  onChange={(e) => handleChange(campo, e.target.value)}
                  rows={4}
                  className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20"
                />
              ) : (
                <input
                  id={`campo-${campo}`}
                  type="text"
                  value={valores[campo] || ''}
                  onChange={(e) => handleChange(campo, e.target.value)}
                  className="h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20"
                />
              )}
            </div>
          ))}

          {mensaje && (
            <div className="md:col-span-2 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-700">
              {mensaje}
            </div>
          )}

          {mensajeError && (
            <div className="md:col-span-2 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {mensajeError}
            </div>
          )}
        </div>
        <div className="flex flex-col-reverse gap-2 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6">
          <button
            type="button"
            onClick={() => navigate('/instrumentos')}
            disabled={guardando}
            className="h-10 rounded-lg border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={handleGuardar}
            disabled={guardando}
            className={`h-10 rounded-lg px-5 text-sm font-semibold text-white transition ${
              guardando
                ? 'cursor-not-allowed bg-slate-400'
                : 'bg-cyan-600 hover:bg-cyan-700'
            }`}
          >
            {guardando ? 'Guardando...' : 'Guardar cambios'}
          </button>
        </div>
      </div>
    </div>
  );
}

